import { useApi } from "hooks"
import { useMutation } from "@tanstack/react-query"
import { RECAPTCHA_TYPES } from "config/constants"

const useForgotCode = () => {

  const { apiFetch } = useApi()

  const url = `/auth/forgotcode/sms`;

  const forgotCode = ({ mobileNumber }) => {
    return apiFetch({
      url,
      method: 'POST',
      data: { mobileNumber },
      captcha: {
        type: RECAPTCHA_TYPES.v3,
        action: 'forgotcode_web'
      }
    })
      .then( res => res.data)
  }

  const {
    mutate,
    ...rest
  } = useMutation(forgotCode)

  return {
    forgotCode: mutate,
    ...rest
  }

}

export default useForgotCode
